import { useQuery, UseQueryResult } from "@tanstack/react-query";
import {
  unitSearch,
  UnitSearchParams,
  UnitSearchResponse,
} from "common/api/citajteo/dl_unit/citajteo_unit";
import { QUERY_KEYS } from "constant/react_query";
import { useUnitSearchOptionsFromUrl } from "./useUnitSearchOptionsFromUrl";

type UnitSearchOptions = {
  initialSearch: boolean;
};

const INITIAL_UNIT_SEARCH_OPTIONS: UnitSearchOptions = {
  initialSearch: true,
};

export const useUnitSearchQuery = (
  searchParams?: UnitSearchParams,
  { initialSearch }: UnitSearchOptions = INITIAL_UNIT_SEARCH_OPTIONS,
): UseQueryResult<UnitSearchResponse, Error> => {
  const { data, refetch, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH, searchParams],
    queryFn: async () => {
      let result = await unitSearch({ ...searchParams });
      if (!result) {
        result = {
          resTotal: 0,
          items: [],
        };
      }
      return result;
    },
    enabled: initialSearch,
  });

  return { data, refetch, ...rest } as UseQueryResult<
    UnitSearchResponse,
    Error
  >;
};

export const useUnitSearch = (searchParams?: UnitSearchParams) => {
  const { data: unit } = useUnitSearchQuery(searchParams);

  const result = unit ?? null;
  return result;
};

export const useUnitSearchRefetch = (
  searchParams?: UnitSearchParams,
): { data: any; refetch: Function } =>
  useUnitSearchQuery(searchParams, { initialSearch: false });

export const useUnitUrlSearch = (isHM2: boolean = false) => {
  const unitSearchParams = useUnitSearchOptionsFromUrl();
  if (isHM2) {
    unitSearchParams["uType"] = "HM2";
  }
  const unitListResult = useUnitSearch(unitSearchParams);

  return unitListResult;
};
